import { useQuery } from '@tanstack/react-query';
import get from 'lodash/get';
import * as Api from '../api';
import * as Mappers from '../mappers';
import * as Types from '../types';
import { keepPageWithinOrg } from './keepPageWithinOrg';

interface IProps {
  params?: Types.IApi.List.Params;
  enabled?: boolean;
}

/** Tests reachable via collections attached to the user's teams. Same shape as useList. */
const useAvailableTests = ({ params, enabled = true }: IProps = {}) => {
  const initialData = { items: [], meta: Mappers.Meta() } as Types.IQuery.List;

  const { data = initialData, ...args } = useQuery<Types.IQuery.List>({
    queryKey: ['test', 'available', JSON.stringify(params)],
    placeholderData: keepPageWithinOrg(params),
    enabled,
    queryFn: async () => {
      const { data: res } = await Api.Available(params);
      const items = (get(res, 'data.items') || []).map(Mappers.Test);
      const meta = Mappers.Meta(get(res, 'data.meta'));
      return { items, meta };
    },
  });

  return { ...args, ...data };
};

export default useAvailableTests;
